export const ASPECT = 8;
export const CHART_WIDTH = "80%";
export const BAR_SIZE = 20;
